import classNames from 'classnames';
import styles from './ToggleButton.module.scss';
import React, {useState} from "react";

function ToggleButton(props: any) {
  const { labelId, className, isChecked, isDisabled, onChange } = props;

  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange(!isChecked)
  }

  return (
    <div className={classNames(styles.toggleButton, className)}>
      <span className={styles.toggleButtonLabel} id={labelId}></span>

      <button
        type="button"
        className={styles.toggleButtonInner}
        role="switch"
        aria-checked={isChecked}
        aria-labelledby={labelId}
        onClick={onClick}
        disabled={isDisabled}
      >
        <span className={styles.toggleButtonIndicator} />
      </button>

        <div className="text-[#94A3B8] italic text-sm hidden sm:block ml-2">
            <div className={"w-[80px]"}>{isChecked ? 'Активен' : 'Неактивен'}</div>
        </div>
    </div>
  );
}

export default ToggleButton;
